module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAdklEQVR42u3QMRGAQBRDwS+Ehg4lZw4vWMzRnIpsZp6A7CSZ5qrPAwAAAAAAAAAAAADw911PmgIAAAAAAAAAAAAAAACAU9sAAAAAAAAAAAAAAAAAIHOvN00BAAAAAAAAAAAAAAAAAIDmAAAAAAAAAAAAAAAobQPc/juZw/OKIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/nl-NL.png
// module id = wGY3
// module chunks = 1